<template>
<div>
    <div v-if="screenshotsScheduled">
        <p-button v-if="collapsed" @click="toggleCollapsed()" type="default" size="sm" outline class="float-right">
            <b-icon icon="clock-history"/>
        </p-button>
        <p-button v-else @click="toggleCollapsed()" type="default" size="sm" outline rounded class="float-right">
            <b-icon icon="x" scale="1.8"></b-icon>
        </p-button>

        <div v-if="!collapsed">
            <b-img center fluid-grow class="screenshot" :src="screenshotURL" />
            <div class="timestamp"><b-icon icon="arrow-clockwise"/>{{ screenshotTimestamp }}</div>

            <vSelect :options="screenshotOptions" :value="dropdownValue" @input="selectScreenshot"
                :reduce="screenshot => screenshot.imagePath" label="timestamp" />

            <!-- <div class="screenshot-list">
                <div v-for="image in screenshots" :key="image.imagePath">
                    <span class="screenshot-list-entry" @click="selectScreenshot(image.imagePath)">{{ reformatTimestamp(image.timestamp) }}</span>
                </div>
            </div> -->
        </div>
    </div>
</div>
</template>

<script>
import screenshotHistory from '@/store/displays/screenshotHistory';
import moment from 'moment';
import vSelect from 'vue-select';

export default {
    components: {
        vSelect
    },
    props: {
        item: { default: null }
    },
    data() {
        return {
            defaultImage: '/traveller-ui/static/traveller/img/not-found.png',
            selectedScreenshot: null,
            collapsed: true,
            dropdownValue: null
        };
    },
    computed: {
        device() {
            return this.item;
        },
        screenshotsScheduled() {
            if (this.device && Array.isArray(this.device.attributes)) {
                for (const a of this.device.attributes) {
                    if (a.name == 'screenshot_schedule') {
                        return true;
                    }
                }
            }
            return false;
        },
        screenshots() {
            if (this.device) {
                let screenshots = this.$store.state.screenshotHistory.screenshots[this.device.deviceId];
                if (screenshots)
                    return screenshots;
            }
            return [];
        },
        screenshotOptions() {
            let options = [];
            for (const screenshot of this.screenshots) {
                options.push({ imagePath: screenshot.imagePath, timestamp: this.reformatTimestamp(screenshot.timestamp) });
            }
            return options;
        },
        screenshotURL() {
            if (this.selectedScreenshot && this.selectedScreenshot.base64) {
                return this.selectedScreenshot.base64;
            }
            return this.defaultImage;
        },
        screenshotTimestamp() {
            if (this.selectedScreenshot && this.selectedScreenshot.timestamp) {
                return this.reformatTimestamp(this.selectedScreenshot.timestamp);
            }
            return '-';
        }
    },
    methods: {
        selectScreenshot(imagePath) {
            this.dropdownValue = imagePath;
            
            for (const sc of this.screenshots) {
                if (sc.imagePath == imagePath) {
                    this.selectedScreenshot = sc;

                    if (!sc.base64) {
                        this.$store.dispatch('screenshotHistory/getScreenshot', { deviceId: this.device.deviceId, imagePath: imagePath });
                    }
                }
            }
        },
        reformatTimestamp(timestamp) {
            try {
                return new moment(timestamp, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm');
            } catch (error) {
                return '-';
            }
        },
        toggleCollapsed() {
            this.collapsed = !this.collapsed;
        }
    },
    beforeCreate() {
        if (!this.$store.state.screenshotHistory) {
             this.$store.registerModule('screenshotHistory', screenshotHistory);
        }
    },
    created() {
        if (this.device) {
            this.$store.dispatch('screenshotHistory/getScreenshotHistory', this.device.deviceId).then(() => {
                if (this.screenshots.length > 0) {
                    this.selectScreenshot(this.screenshots[0].imagePath);
                }
            });
        }
    }
}
</script>

<style scoped lang="scss">
.screenshot {
    border: 1px solid #6c757d;
    border: 1px solid #dee2e6
}
.timestamp {
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1px;
    
    border: 1px solid #6c757d;
    border: 1px solid #dee2e6;
    border-top: 0;
    padding: 4px 10px 2px 10px;
    margin-top: -1px;
    margin-bottom: 10px;
  
    text-align: center;

    color:  #000;

    display: inline-block;

    border-radius: 0 0 3px 3px;

    background-color: rgba(0, 0, 0, 0.05);
}

.timestamp svg {
    margin-right: 8px;
}

.screenshot-list {
    height: 250px;
    overflow: auto;
}

.screenshot-list-entry {
    cursor: pointer;
}
</style>